export default __webpack_public_path__ + "static/media/proca-icon-dark.e8754aa1.png";